module.exports = __webpack_public_path__ + "static/img/sub_page_banner_12.efc4f0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sub_page_banner_12.jpg
// module id = kqgu
// module chunks = 0